import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Pagination } from 'swiper/modules';
import { Helmet } from "react-helmet";
import NotFound from './NotFound';

function DestinationList() {
const { slug } = useParams();
const [DestinationData, setDestinationData] = useState(null);
const [exp, setExp] = useState(null);
const [reexp, setReExp] = useState(null);
const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
useEffect(() => {
  fetch("https://planjourneysglobal.com/admin/api/recent_experience")
    .then(res => res.json())
    .then(res => setReExp(res.data || {}))
    .catch(err => console.log(err));
}, []);


useEffect(() => {
  fetch("https://planjourneysglobal.com/admin/api/popularlocations/byCategory/europe")
    .then(res => res.json())
    .then(res => setExp(res.data || {}))
    .catch(err => console.log(err));
}, []);
useEffect(() => {
  if (!slug) return;

  setLoading(true);
  setNotFound(false);

  fetch(`https://planjourneysglobal.com/admin/api/locations/${slug}`)
    .then((res) => res.json())
    .then((data) => {

      if (data?.status && data?.data) {
        const d = data.data;

        const bestTime = d.best_time_to_visit
          ? JSON.parse(d.best_time_to_visit)
          : [];

        const faqs = d.faqs
          ? JSON.parse(d.faqs)
          : [];

        setDestinationData({
          ...d,
          best_time_to_visit: bestTime,
          faqs: faqs
        });

        setNotFound(false);
      } else {
        setDestinationData(null);
        setNotFound(true);
      }

      setLoading(false);
    })
    .catch((err) => {
      console.error("Fetch Error:", err);

      setDestinationData(null);
      setNotFound(true);
      setLoading(false);
    });

}, [slug]);

// useEffect(() => {
//   if (!slug) return;

//   setLoading(true);

//   fetch(`https://planjourneysglobal.com/admin/api/locations/${slug}`)
//     .then((res) => res.json())
//     .then((data) => {
//       if (data.status) {
//         const d = data.data;

//         const bestTime = d.best_time_to_visit
//           ? JSON.parse(d.best_time_to_visit)
//           : [];

//         const faqs = d.faqs ? JSON.parse(d.faqs) : [];

//         setDestinationData({
//           ...d,
//           best_time_to_visit: bestTime,
//           faqs: faqs
//         });
//       }
//       setLoading(false);
//         setNotFound(true); // add this
//     })
//     .catch((err) => {
//       console.error("Fetch Error:", err);
//       setLoading(false);
//           setNotFound(true); // add this
//     });
// }, [slug]);




const validFaqs =
  DestinationData?.faqs?.filter(
    faq => faq?.question?.trim() && faq?.answer?.trim()
  ) || [];

if (loading) return <p></p>;

if (notFound) return <NotFound />;


  return (
    <>
    <Helmet>
          {/* <title>{DestinationData.name}</title>
          <meta name="description" content={DestinationData.meta_description} /> */}
          <meta name="keyword" content={DestinationData.meta_keyword} />
          {/* {DestinationData.slug && <link rel="canonical" href={DestinationData.slug} />}
    
  
          <meta property="og:title" content={DestinationData.name} />
          <meta property="og:description" content={DestinationData.meta_description} />
          {DestinationData.image && (
              <meta
                property="og:image"
                content={`https://planjourneysglobal.com/admin/${DestinationData.image}`}
              />
            )}      
             {DestinationData.image && (
          <meta name="twitter:image"
            content={`https://planjourneysglobal.com/admin/${DestinationData.image}`}
          />
        )}
         {DestinationData.slug && (
  <link
    rel="canonical"
    href={`https://planjourneysglobal.com/${DestinationData.slug}`}
  />
)}

{DestinationData.slug && (
  <meta
    property="og:url"
    content={`https://planjourneysglobal.com/${DestinationData.slug}`}
  />
)}
          <meta property="og:type" content="website" />
    
       
          <meta name="twitter:title" content={DestinationData.name} />
          <meta name="twitter:description" content={DestinationData.meta_description} />
          <meta name="twitter:card" content="summary_large_image" /> */}
        </Helmet>
      <Header />
<>

<div
  className="breadcrumb-section"
  style={{
    backgroundImage: DestinationData?.banner_image
      ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), 
         url("https://planjourneysglobal.com/admin/${DestinationData.banner_image}")`
      : "none",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="container">
    <div className="banner-content">
      <h1 dangerouslySetInnerHTML={{ __html: DestinationData?.name }} />
    </div>
  </div>
</div>


  {/* Destination Details Section Start*/}
  <div className="destination-details-section mb-0 mt-5">
    <div className="container">
      <div
        className="row justify-content-center mb-0 wow animate fadeInDown"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <div className="col-lg-10">
          <div className="destination-details-content">
            <h2>{DestinationData.name}</h2>
            <ul className="destination-info">
              <li>
                <div className="content">
                  <span>Capital -</span> {DestinationData.capital}
                </div>
              </li>
              <li>
                <div className="content">
                  <span>Currency -</span>{DestinationData.currency}
                </div>
                
              </li>
              <li>
                <div className="content">
                  <span>Language -</span> {DestinationData.language}
                </div>
                <div className="info">
                  <svg
                    width={12}
                    height={12}
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path d="M6 0.375C4.88748 0.375 3.79995 0.704901 2.87492 1.32298C1.94989 1.94107 1.22892 2.81957 0.80318 3.84741C0.377437 4.87524 0.266043 6.00624 0.483085 7.09738C0.700127 8.18853 1.23586 9.19081 2.02253 9.97748C2.8092 10.7641 3.81148 11.2999 4.90262 11.5169C5.99376 11.734 7.12476 11.6226 8.1526 11.1968C9.18043 10.7711 10.0589 10.0501 10.677 9.12508C11.2951 8.20006 11.625 7.11252 11.625 6C11.6245 4.50831 11.0317 3.07786 9.97693 2.02307C8.92215 0.968289 7.49169 0.375497 6 0.375ZM6 9.375C5.85167 9.375 5.70666 9.33101 5.58333 9.2486C5.45999 9.16619 5.36386 9.04906 5.30709 8.91201C5.25033 8.77497 5.23548 8.62417 5.26441 8.47868C5.29335 8.3332 5.36478 8.19956 5.46967 8.09467C5.57456 7.98978 5.7082 7.91835 5.85369 7.88941C5.99917 7.86047 6.14997 7.87533 6.28702 7.93209C6.42406 7.98886 6.54119 8.08499 6.62361 8.20832C6.70602 8.33166 6.75 8.47666 6.75 8.625C6.74941 8.82373 6.6702 9.01415 6.52968 9.15468C6.38915 9.2952 6.19873 9.37441 6 9.375ZM6.85875 3.55875L6.6075 6.56625C6.5944 6.71834 6.52472 6.85999 6.41224 6.9632C6.29976 7.0664 6.15266 7.12367 6 7.12367C5.84735 7.12367 5.70024 7.0664 5.58776 6.9632C5.47528 6.85999 5.40561 6.71834 5.3925 6.56625L5.14125 3.55875C5.13042 3.44226 5.1434 3.32478 5.1794 3.21346C5.2154 3.10214 5.27367 2.99931 5.35067 2.91123C5.42767 2.82314 5.52178 2.75165 5.62729 2.70108C5.73279 2.65052 5.84748 2.62195 5.96437 2.61711C6.08127 2.61227 6.19793 2.63126 6.30725 2.67294C6.41657 2.71461 6.51627 2.77808 6.60029 2.8595C6.6843 2.94092 6.75087 3.03858 6.79595 3.14655C6.84103 3.25451 6.86367 3.37051 6.8625 3.4875C6.86313 3.51131 6.86187 3.53514 6.85875 3.55875Z" />
                    </g>
                  </svg>
                  {/* <div className="tooltip-text">
                    English is widely spoken in tourist areas.
                  </div> */}
                </div>
              </li>
            </ul>
            <div dangerouslySetInnerHTML={{ __html: DestinationData.description }}>

            </div>
          </div>
        </div>
      </div>
    {DestinationData?.packages?.length > 0 && (
  <div className="location-slider-wrap text-center">
    <h2>Relevant Packages</h2>

    <div className="location-slider-area mt-30 mb-30">
      <div className="swiper destination-dt-location-slider">

        <Swiper
          modules={[Navigation, Pagination]}
          slidesPerView={5}
          spaceBetween={10}
          navigation={true}
           autoplay={{
        delay: 2000,
        disableOnInteraction: false,
         pauseOnMouseEnter: true, // 👈 ADD THIS
      }}
      loop={true}
         breakpoints={{
          0: {
            slidesPerView: 1, // Mobile
          },
          640: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: 5, // Desktop
          },
        }}
        >
          {DestinationData?.packages?.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="location-card">

                <div className="location-img">
                  <img
                    src={item.image}
                    alt={item.title}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/assets/img/no-image.png";
                    }}
                  />
                </div>

                <div className="location-content">
                  <h6>
                    <Link to={`/tour-package/${item.slug}`}>
                      {item.title}
                    </Link>
                  </h6>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </div>
  </div>
)}

      <div className="location-slider-wrap d-none"> 
        <h4>Popular Tourist Place</h4>
        <div className="location-slider-area">
          <div className="swiper destination-dt-location-slider">
            <Swiper modules={[Navigation,Pagination]}
               slidesPerView={6}
               spaceBetween={10}
               navigation={true}
              loop={true}
                breakpoints={{
                0: {
                  slidesPerView: 1, // Mobile
                },
                640: {
                  slidesPerView: 2, // Tablet
                },
                1024: {
                  slidesPerView: 4, // Desktop
                },
              }}
              >
            {Array.isArray(exp) && exp.length > 0 && exp.map((item, index) => (
  <SwiperSlide key={index}>
    <div className="location-card">
      <div className="location-img">
        <img
          src={`https://planjourneysglobal.com/admin/${item.image}`}
          alt={item.name}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/assets/img/no-image.png";
          }}
        />
      </div>

      <div className="location-content">
        <h6>
          <Link to={`/destination/${item.slug}`}>{item.name}</Link>
        </h6>
      </div>
    </div>
  </SwiperSlide>
))}

            </Swiper>
          </div>

        </div>
      </div>
     
    </div>
  </div>
 
  {/* Destination Details Section End*/}
  {/* Destination Details Why Choose Section Start*/}
  <div className="destination-dt-why-choose-section mb-100 ">
    <div className="container">
      <div
        className="row justify-content-center mb-30 wow animate fadeInDown"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <div className="col-xl-6 col-lg-8">
          <div className="section-title text-center">
            <h2>Why Choose Only Us?</h2>
            <p>
              Because we don’t just plan your trip — we craft unforgettable
              experiences.
            </p>
          </div>
        </div>
      </div>
      <div className="row g-4">
        <div
          className="col-lg-4 col-md-6 wow animate fadeInDown"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <div className="why-choose-card">
            <svg
              width={55}
              height={55}
              viewBox="0 0 55 55"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39.4083 46.76L38.9726 46.8768C37.6348 41.6857 32.9461 38.0057 27.4996 38.0057C22.0537 38.0057 17.3651 41.6858 16.0272 46.8768L7.45727 44.5811C8.27508 41.4718 9.80159 38.668 11.8355 36.3293L15.6035 40.0967C16.1294 40.6213 17.0273 40.2447 17.0273 39.5076C17.0272 39.398 17.0055 39.2895 16.9635 39.1883C16.9215 39.0871 16.8599 38.9952 16.7824 38.9179L12.9791 35.1146C15.2579 32.8786 18.04 31.1699 21.1035 30.1621L22.4878 35.3292C22.6079 35.7782 23.0653 36.0345 23.5083 35.9176C23.614 35.8893 23.7131 35.8405 23.7999 35.7739C23.8867 35.7073 23.9595 35.6242 24.0142 35.5294C24.0688 35.4346 24.1042 35.33 24.1184 35.2215C24.1325 35.113 24.1252 35.0028 24.0967 34.8971L22.7067 29.7053C25.8568 28.9442 29.1428 28.9442 32.2929 29.7053L30.9015 34.8971C30.7605 35.4264 31.1594 35.9464 31.7073 35.9464C32.0762 35.9464 32.4125 35.7009 32.5117 35.3292L33.896 30.1621C36.9589 31.1699 39.7416 32.8786 42.0204 35.1146L38.2171 38.9179C37.6891 39.4459 38.073 40.3409 38.8055 40.3409C39.0269 40.341 39.2393 40.2531 39.396 40.0967L43.1633 36.3293C45.1979 38.668 46.7244 41.4718 47.5422 44.5811L39.4083 46.76ZM27.4996 53.3334C29.4174 53.3334 30.977 51.7738 30.977 49.8559C30.977 47.9389 29.4174 46.3779 27.4996 46.3779C25.5825 46.3779 24.0221 47.9389 24.0221 49.8559C24.0223 51.7739 25.5825 53.3334 27.4996 53.3334ZM18.2879 45.5003C18.0149 46.0813 17.7979 46.687 17.6397 47.3091L22.5084 48.6132C22.5572 48.4191 22.6169 48.2278 22.6872 48.0404L18.2879 45.5003ZM21.7012 41.4789C20.6929 42.1756 19.8191 43.049 19.1218 44.0568L23.5226 46.5982C23.738 46.3352 23.9789 46.0943 24.2418 45.8788L21.7012 41.4789ZM26.6664 44.7804V39.7076C25.4207 39.8088 24.2306 40.1326 23.1446 40.6457L25.6839 45.0436C26.0018 44.9233 26.3309 44.8351 26.6664 44.7804ZM31.4774 46.5983L35.8782 44.0569C35.181 43.0492 34.3074 42.1759 33.2996 41.479L30.7582 45.8791C31.0213 46.0943 31.2622 46.3352 31.4774 46.5983ZM32.3113 48.0403C32.3828 48.2274 32.443 48.4187 32.4915 48.6131L37.3602 47.3089C37.2022 46.6867 36.9849 46.081 36.7114 45.5002L32.3113 48.0403ZM31.8545 40.6457C30.7693 40.1326 29.5793 39.8088 28.3329 39.7076V44.7804C28.6686 44.8352 28.9979 44.9234 29.3161 45.0436L31.8545 40.6457ZM25.4593 26.3223C26.7931 26.7583 28.2066 26.7575 29.5405 26.3223V27.5623C28.183 27.4366 26.8168 27.4366 25.4593 27.5623V26.3223ZM23.4191 23.0125C23.3933 22.9272 23.3544 22.8464 23.3036 22.7731C22.469 21.5943 21.8715 20.2621 21.526 18.8095C21.3437 18.0768 21.3458 17.4048 21.5316 16.5609C21.6682 15.9359 21.906 15.0893 22.3874 14.9471C23.0312 14.7549 24.2645 15.6313 26.1948 14.8204C26.7205 14.5994 27.1582 14.2799 27.4996 13.8802C27.8416 14.2799 28.2794 14.5995 28.8051 14.8204C30.7355 15.6313 31.9685 14.7549 32.6125 14.9471C33.0938 15.0893 33.3317 15.9359 33.4683 16.5602C33.6541 17.4048 33.6562 18.0768 33.4726 18.8165C33.1284 20.2621 32.5301 21.5937 31.6962 22.7733C31.6449 22.8462 31.6059 22.927 31.5808 23.0126C30.4448 24.2857 29.007 24.9824 27.4996 24.9824C25.9928 24.9823 24.555 24.2856 23.4191 23.0125ZM20.9769 22.7056C21.0769 22.7013 21.1761 22.6943 21.2739 22.6844C20.6595 21.6076 20.2014 20.4421 19.9057 19.2035C19.6637 18.226 19.663 17.2991 19.9037 16.2032C20.0627 15.4797 20.4336 13.7865 21.9137 13.348C23.2577 12.9502 24.06 13.9095 25.5495 13.2832C26.2389 12.9933 26.569 12.4669 26.6664 11.7068V8.01345C24.9885 8.32242 23.4558 8.91995 22.1003 9.79542C19.2007 11.6702 15.8782 16.2653 17.183 20.0171C17.7761 21.7259 19.2668 22.7823 20.9769 22.7056ZM21.0868 6.67349H22.2747L21.6892 8.09372L21.0868 8.46817V6.67349ZM27.4996 2.88856C29.6319 2.88856 30.1624 4.57425 31.0839 7.0422C29.9867 6.63892 28.8227 6.36233 27.5974 6.21805H27.4024C26.1772 6.36233 25.0124 6.63892 23.9158 7.0422C24.8311 4.54945 25.3925 2.88856 27.4996 2.88856ZM33.9125 8.46804L33.3108 8.09359C33.0962 7.6368 32.9055 7.15399 32.7253 6.67337H33.9125V8.46804ZM37.817 20.0171C39.1218 16.2653 35.7993 11.6702 32.899 9.79542C31.5448 8.91995 30.0114 8.32242 28.3329 8.01345V11.7069C28.4377 12.4691 28.754 12.9908 29.4505 13.2834C30.9415 13.9096 31.7411 12.9502 33.0863 13.3481C34.5663 13.7866 34.9371 15.4798 35.0962 16.2033C35.3369 17.2992 35.3361 18.2267 35.0913 19.2099C34.7985 20.4437 34.3403 21.6091 33.7259 22.6846C35.5802 22.8707 37.1798 21.8526 37.817 20.0171ZM49.3577 44.9957C48.4948 41.1003 46.5764 37.4898 43.8569 34.5748C43.3058 33.9498 42.2651 33.0055 41.6069 32.4712C39.2478 30.5548 36.5235 29.15 33.626 28.3245C33.0616 28.1393 31.7902 27.8775 31.207 27.779V25.5234C31.7539 25.1666 32.2669 24.7281 32.7392 24.213C33.2043 24.3149 33.7026 24.3756 34.1882 24.3756C36.5185 24.3756 38.5904 22.8688 39.3913 20.5632C40.6539 16.9345 38.5672 12.5668 35.5796 9.78687V7.53137L43.4549 7.56375C43.9138 7.56375 44.286 7.1921 44.2882 6.73324C44.2903 6.2729 43.9181 5.89857 43.4577 5.8965L36.0758 5.86693L40.896 1.44793C41.2358 1.13689 41.2584 0.61046 40.9473 0.269729C40.637 -0.0688028 40.1091 -0.0920151 39.7705 0.219029L34.547 5.00686H32.0972C31.3089 3.05666 30.1977 1.22192 27.4993 1.22192C24.8004 1.22192 23.6904 3.05666 22.9022 5.00686H20.4523L15.2289 0.219029C14.8903 -0.0912821 14.3624 -0.0688028 14.0521 0.269729C13.7411 0.610338 13.7635 1.13677 14.1034 1.44793L18.8456 5.79448L11.5446 5.76419C11.0857 5.76419 10.7135 6.13583 10.7113 6.5947C10.7092 7.05491 11.0814 7.43009 11.541 7.43144L19.4199 7.46454V9.78699C16.4323 12.567 14.3457 16.9346 15.6082 20.5633C16.4402 22.9565 18.6189 24.4697 21.0512 24.3715C21.458 24.353 21.8625 24.3 22.2603 24.2131C22.7325 24.7283 23.2456 25.1668 23.7925 25.5235V27.7792C19.9776 28.4227 16.4272 30.0083 13.3926 32.4712C9.50044 35.6304 6.72719 40.0915 5.64183 44.9957C5.59533 45.2053 5.63161 45.4247 5.7431 45.6082C5.85458 45.7917 6.03265 45.9249 6.2401 45.9802L22.3757 50.3036C22.603 52.9316 24.8135 54.9999 27.4992 54.9999C30.1856 54.9999 32.3954 52.9314 32.6235 50.3036L48.759 45.9802C48.9665 45.9249 49.1446 45.7916 49.2561 45.6082C49.3676 45.4247 49.404 45.2053 49.3577 44.9957Z"
              />
            </svg>
            <h4>Local Expertise</h4>
            <p>
              From secret spots in Montmartre to skip-the-line Eiffel Tower
              access — we curate every journey with insider knowledge.
            </p>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6 wow animate fadeInDown"
          data-wow-delay="400ms"
          data-wow-duration="1500ms"
        >
          <div className="why-choose-card">
            <svg
              width={55}
              height={55}
              viewBox="0 0 55 55"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M50.0319 31.8411L38.6003 12.041C38.4964 11.861 38.3269 11.7281 38.1273 11.6702L30.1219 9.3456C30.1825 8.94583 30.2132 8.54209 30.2136 8.13774C30.2136 3.70981 26.6112 0.107422 22.1833 0.107422C17.7554 0.107422 14.153 3.70981 14.153 8.13774C14.153 9.81481 14.6705 11.373 15.5532 12.6624L4.77913 24.0472C4.63753 24.1969 4.55861 24.395 4.55859 24.601V51.1973C4.55859 53.235 6.21644 54.8926 8.25412 54.8926H36.1124C38.1502 54.8926 39.8079 53.2348 39.8079 51.1973V41.2852L48.9093 36.0305C49.6166 35.6222 50.1232 34.9606 50.3356 34.1676C50.5482 33.3746 50.4403 32.5483 50.0319 31.8411ZM15.7643 8.13774C15.7643 4.5983 18.6439 1.71875 22.1833 1.71875C25.7227 1.71875 28.6023 4.5983 28.6023 8.13774C28.6023 8.38965 28.5859 8.64145 28.5567 8.89109L23.9758 7.56089C23.4824 7.1051 22.8668 6.86469 22.1833 6.86469C21.4352 6.86469 20.7679 7.15193 20.2538 7.69517L16.6921 11.4588C16.0839 10.4579 15.7629 9.30894 15.7643 8.13774ZM38.1966 51.1973C38.1966 52.3464 37.2616 53.2812 36.1124 53.2812H8.25423C7.10503 53.2812 6.17003 52.3464 6.17003 51.1973V24.9219L16.5996 13.9009C18.0459 15.3027 20.015 16.168 22.1833 16.168C22.6284 16.168 22.989 15.8073 22.989 15.3623C22.989 14.9172 22.6284 14.5566 22.1833 14.5566C20.4432 14.5566 18.8636 13.8596 17.7063 12.7314L21.4242 8.80279C21.6351 8.57989 21.8764 8.47602 22.1833 8.47602C22.4902 8.47602 22.7316 8.57989 22.9426 8.80279L38.1966 24.9219V51.1973ZM48.7792 33.7506C48.6782 34.1278 48.4382 34.442 48.1037 34.6351L39.8079 39.4246V24.6011C39.8079 24.3951 39.729 24.1969 39.5874 24.0474L26.179 9.87852L37.3667 13.1272L48.6364 32.6469C48.8296 32.9813 48.8802 33.3733 48.7792 33.7506ZM10.5639 31.5021C10.5639 37.9091 15.7762 43.1214 22.1832 43.1214C28.5902 43.1214 33.8026 37.9091 33.8026 31.5021C33.8026 25.0951 28.5902 19.8827 22.1832 19.8827C15.7762 19.8827 10.5639 25.0951 10.5639 31.5021ZM32.1913 31.5021C32.1913 37.0205 27.7017 41.5101 22.1832 41.5101C16.6648 41.5101 12.1752 37.0205 12.1752 31.5021C12.1752 25.9836 16.6648 21.494 22.1832 21.494C27.7017 21.494 32.1913 25.9836 32.1913 31.5021ZM13.7978 31.5021C13.7978 36.1259 17.5595 39.8876 22.1832 39.8876C26.807 39.8876 30.5687 36.1259 30.5687 31.5021C30.5687 26.8784 26.807 23.1167 22.1832 23.1167C17.5595 23.1167 13.7978 26.8784 13.7978 31.5021ZM28.9572 31.5021C28.9572 35.2373 25.9184 38.2762 22.1831 38.2762C18.4478 38.2762 15.4091 35.2374 15.4091 31.5021C15.4091 27.7668 18.4478 24.728 22.1831 24.728C25.9184 24.728 28.9572 27.7668 28.9572 31.5021ZM22.1832 25.7782C22.6282 25.7782 22.9889 26.1389 22.9889 26.5839V27.1482C24.0532 27.4897 24.8258 28.4888 24.8258 29.6652C24.8258 30.1102 24.4652 30.4709 24.0201 30.4709C23.5751 30.4709 23.2144 30.1102 23.2144 29.6652C23.2144 29.0966 22.7518 28.6339 22.1832 28.6339H22.012C21.4433 28.6339 20.9806 29.0966 20.9806 29.6652C20.9806 30.2339 21.4433 30.6966 22.012 30.6966H22.3544C23.8115 30.6966 24.9971 31.8821 24.9971 33.3392C24.9971 34.5777 24.1406 35.62 22.989 35.9049V36.4205C22.989 36.8656 22.6284 37.2262 22.1833 37.2262C21.7383 37.2262 21.3776 36.8656 21.3776 36.4205V35.8563C20.3133 35.5149 19.5407 34.5156 19.5407 33.3392C19.5407 32.8942 19.9013 32.5336 20.3464 32.5336C20.7914 32.5336 21.1521 32.8942 21.1521 33.3392C21.1521 33.9079 21.6147 34.3706 22.1833 34.3706H22.3545C22.9232 34.3706 23.3859 33.9079 23.3859 33.3392C23.3859 32.7705 22.9232 32.3079 22.3545 32.3079H22.0121C20.555 32.3079 19.3694 31.1224 19.3694 29.6652C19.3694 28.4267 20.2259 27.3845 21.3775 27.0996V26.5839C21.3775 26.1389 21.7381 25.7782 22.1832 25.7782ZM31.0777 45.1744H13.2887C13.1829 45.1744 13.0781 45.1953 12.9803 45.2357C12.8826 45.2762 12.7938 45.3356 12.7189 45.4104C12.6441 45.4852 12.5848 45.574 12.5443 45.6718C12.5038 45.7695 12.483 45.8743 12.483 45.9801V49.4447C12.483 49.8897 12.8436 50.2503 13.2887 50.2503H31.0777C31.5228 50.2503 31.8834 49.8897 31.8834 49.4447V45.9801C31.8834 45.7664 31.7985 45.5615 31.6474 45.4104C31.4963 45.2593 31.2914 45.1744 31.0777 45.1744ZM30.2721 48.639H14.0943V46.7858H30.2721V48.639Z" />
            </svg>
            <h4>Transparent Pricing</h4>
            <p>
              From secret spots in Montmartre to skip-the-line Eiffel Tower
              access — we curate every journey with insider knowledge.
            </p>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6 wow animate fadeInDown"
          data-wow-delay="600ms"
          data-wow-duration="1500ms"
        >
          <div className="why-choose-card">
            <svg
              width={55}
              height={55}
              viewBox="0 0 55 55"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M27.47 20.0587H24.8988L27.4468 17.4883C27.87 17.0586 28.1573 16.5139 28.273 15.922C28.3886 15.3302 28.3276 14.7173 28.0974 14.16C27.6454 13.0488 26.6321 12.3467 25.3989 12.3269C24.4918 12.3278 23.622 12.6885 22.9805 13.3299C22.339 13.9713 21.9781 14.8409 21.9769 15.7481C21.9769 15.976 22.0675 16.1946 22.2286 16.3557C22.3898 16.5169 22.6084 16.6075 22.8363 16.6075C23.0642 16.6075 23.2828 16.5169 23.444 16.3557C23.6051 16.1946 23.6957 15.976 23.6957 15.7481C23.6957 14.8096 24.4596 14.0457 25.4264 14.0457C26.1243 14.0568 26.4121 14.5828 26.5041 14.8079C26.67 15.2153 26.6837 15.8151 26.2248 16.2775L22.2244 20.3122C22.1054 20.4328 22.0247 20.5859 21.9924 20.7523C21.96 20.9186 21.9776 21.0908 22.0427 21.2472C22.1079 21.4036 22.2178 21.5373 22.3587 21.6315C22.4996 21.7257 22.6651 21.7762 22.8346 21.7766H27.4683C27.6962 21.7766 27.9148 21.6861 28.076 21.5249C28.2372 21.3637 28.3277 21.1451 28.3277 20.9172C28.3277 20.6893 28.2372 20.4707 28.076 20.3095C27.9148 20.1484 27.6962 20.0578 27.4683 20.0578L27.47 20.0587Z" />
              <path d="M31.9678 20.9172C31.9678 21.1451 32.0583 21.3637 32.2195 21.5249C32.3807 21.6861 32.5993 21.7766 32.8272 21.7766C33.0551 21.7766 33.2737 21.6861 33.4348 21.5249C33.596 21.3637 33.6866 21.1451 33.6866 20.9172V13.1837C33.6867 13.0038 33.6303 12.8283 33.5254 12.6821C33.4205 12.5359 33.2724 12.4264 33.1019 12.3688C32.9314 12.3113 32.7472 12.3087 32.5752 12.3615C32.4032 12.4143 32.252 12.5197 32.1431 12.6629L27.9433 18.187C27.8463 18.3144 27.7868 18.4664 27.7715 18.6259C27.7562 18.7853 27.7858 18.9459 27.857 19.0894C27.9281 19.2329 28.0379 19.3537 28.1741 19.4381C28.3102 19.5225 28.4672 19.5672 28.6274 19.5671H31.9678V20.9172ZM30.3599 17.8484L31.9678 15.7343V17.8484H30.3599ZM42.4075 22.9711H37.1945C36.9666 22.9711 36.748 23.0617 36.5869 23.2228C36.4257 23.384 36.3351 23.6026 36.3351 23.8305C36.3351 24.0584 36.4257 24.277 36.5869 24.4382C36.748 24.5993 36.9666 24.6899 37.1945 24.6899H40.7919L36.4821 31.0845C36.4168 31.178 36.3707 31.2835 36.3466 31.395C36.3225 31.5065 36.3208 31.6217 36.3416 31.7338C36.3625 31.846 36.4054 31.9528 36.468 32.0482C36.5306 32.1436 36.6115 32.2255 36.7061 32.2893C36.8006 32.3531 36.9069 32.3974 37.0188 32.4196C37.1307 32.4419 37.2459 32.4416 37.3576 32.4189C37.4694 32.3962 37.5755 32.3515 37.6699 32.2873C37.7642 32.2232 37.8448 32.1409 37.9069 32.0453L43.1199 24.3109C43.2071 24.1816 43.2574 24.0311 43.2656 23.8754C43.2737 23.7197 43.2393 23.5647 43.1661 23.427C43.0929 23.2894 42.9836 23.1742 42.85 23.0939C42.7164 23.0136 42.5634 22.9712 42.4075 22.9711ZM39.8302 13.3607C39.6285 13.2548 39.393 13.2333 39.1754 13.301C38.9579 13.3687 38.7761 13.52 38.6701 13.7217L29.9663 30.2896C29.9107 30.3897 29.8756 30.4999 29.8632 30.6138C29.8508 30.7277 29.8612 30.8429 29.894 30.9527C29.9267 31.0624 29.9811 31.1646 30.0539 31.253C30.1266 31.3415 30.2164 31.4145 30.3178 31.4678C30.4192 31.5211 30.5302 31.5535 30.6443 31.5633C30.7585 31.573 30.8734 31.5599 30.9824 31.5245C31.0914 31.4892 31.1922 31.4325 31.2789 31.3577C31.3656 31.2828 31.4365 31.1914 31.4874 31.0888L40.1912 14.5209C40.2971 14.3192 40.3186 14.0836 40.2509 13.8661C40.1832 13.6485 40.0319 13.4668 39.8302 13.3607Z" />
              <path d="M32.0547 1.71878C27.3069 1.70491 22.6927 3.28961 18.9553 6.21762C15.2179 9.14563 12.5749 13.2465 11.4521 17.8596L10.5523 16.9598C9.35088 15.7575 7.25401 15.7575 6.05088 16.9598L5.01447 17.9962C4.94315 18.0675 4.88299 18.1449 4.81424 18.2179C4.79447 18.2342 4.76955 18.2411 4.75065 18.26C4.71971 18.291 4.70596 18.3314 4.68018 18.3666C0.642834 22.776 0.745958 29.6407 5.01447 33.9093L21.0917 49.9864C23.2848 52.1804 26.1663 53.277 29.0478 53.277C31.9292 53.277 34.8107 52.1804 37.0038 49.9864L38.0403 48.95C38.6418 48.3485 38.9727 47.5493 38.9727 46.6993C38.9727 45.8494 38.6418 45.0502 38.0403 44.4486L37.1405 43.5489C41.7536 42.426 45.8544 39.783 48.7824 36.0456C51.7104 32.3082 53.2951 27.694 53.2813 22.9462C53.2813 11.2415 43.7585 1.71878 32.0547 1.71878ZM36.8251 47.734L35.7887 48.7704C32.071 52.4881 26.0236 52.4872 22.3068 48.7704L6.22963 32.6932C2.80846 29.2721 2.54463 23.8812 5.42096 20.1455L11.0834 25.8079C11.163 25.888 11.2577 25.9516 11.3619 25.9949C11.4662 26.0383 11.578 26.0606 11.691 26.0606C11.8039 26.0606 11.9157 26.0383 12.02 25.9949C12.1242 25.9516 12.2189 25.888 12.2985 25.8079C12.3784 25.7282 12.4418 25.6335 12.485 25.5292C12.5283 25.425 12.5505 25.3132 12.5505 25.2003C12.5505 25.0875 12.5283 24.9757 12.485 24.8715C12.4418 24.7672 12.3784 24.6725 12.2985 24.5928L6.57338 18.8676L7.26604 18.175C7.54276 17.8982 7.91057 17.7461 8.30158 17.7461C8.6926 17.7461 9.06041 17.8982 9.33713 18.175L14.6928 23.5297C14.9668 23.8047 15.1207 24.1771 15.1207 24.5653C15.1207 24.9535 14.9668 25.3258 14.6928 25.6008L13.3951 26.8985C12.6628 27.6322 12.2516 28.6265 12.2516 29.6631C12.2516 30.6997 12.6628 31.694 13.3951 32.4277L22.5655 41.5981C23.8795 42.9129 25.9024 43.0874 27.4124 42.1352L33.1977 47.9205C33.2773 48.0006 33.372 48.0641 33.4762 48.1075C33.5805 48.1509 33.6923 48.1732 33.8053 48.1732C33.9182 48.1732 34.03 48.1509 34.1343 48.1075C34.2385 48.0641 34.3332 48.0006 34.4128 47.9205C34.4927 47.8408 34.5561 47.7461 34.5993 47.6418C34.6425 47.5375 34.6648 47.4258 34.6648 47.3129C34.6648 47.2001 34.6425 47.0883 34.5993 46.984C34.5561 46.8798 34.4927 46.7851 34.4128 46.7053L28.6997 40.9922L29.3924 40.2996C29.6673 40.0255 30.0397 39.8716 30.4279 39.8716C30.8161 39.8716 31.1885 40.0255 31.4635 40.2996L36.8251 45.6621C37.1018 45.9388 37.2539 46.3066 37.2539 46.6976C37.2539 47.0886 37.1018 47.4573 36.8251 47.734ZM35.6933 42.1008L32.6786 39.0861C32.081 38.4905 31.2717 38.156 30.4279 38.156C29.5842 38.156 28.7748 38.4905 28.1772 39.0861L26.8796 40.3838C26.4684 40.7943 25.9111 41.0248 25.3301 41.0248C24.7491 41.0248 24.1918 40.7943 23.7806 40.3838L14.6103 31.2134C14.2 30.8021 13.9696 30.2449 13.9696 29.6639C13.9696 29.083 14.2 28.5258 14.6103 28.1145L15.9079 26.8168C16.504 26.2194 16.8387 25.41 16.8387 24.5661C16.8387 23.7222 16.504 22.9128 15.9079 22.3154L12.8992 19.3076C13.732 14.8397 16.1047 10.8052 19.6046 7.90576C23.1044 5.00635 27.5099 3.42556 32.0547 3.43839C42.8115 3.43839 51.5625 12.1894 51.5625 22.9462C51.5752 27.491 49.9943 31.8964 47.095 35.3962C44.1956 38.896 40.1611 41.2679 35.6933 42.1008Z" />
            </svg>
            <h4>24/7 Support</h4>
            <p>
              From secret spots in Montmartre to skip-the-line Eiffel Tower
              access — we curate every journey with insider knowledge.
            </p>
          </div>
        </div>
      </div>
      <ul>
        <li>Personalized Itineraries</li>
        <li>Trusted Guides &amp; Partners</li>
        <li>Curated Experiences</li>
      </ul>
    </div>
  </div>
  {/* Destination Details Why Choose Section End*/}
  {/* Destination Details customer gallery Section Start*/}
    {reexp?.length > 0 && (
  <div className="destionation-dt-customer-gallery-section mb-100 d-none">
    <div className="container-fluid">
      <div
        className="section-title text-center mb-60 wow animate fadeInDown"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <h2>Recent Customer Experience</h2>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="swiper destionation-dt-customer-gallery-slider">
            <Swiper modules={[Navigation, Pagination]}
                  spaceBetween={15}
                  slidesPerView={5}
                  pagination={{ clickable: true }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  loop={true}>
              {reexp.map((item, index) => (
              <SwiperSlide className="swiper-slide" key={index}>
                <img
                  src={item.images}
                  alt={item.images}
                />
              </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
    )}
  {/* Destination Details customer gallery Section End*/}
  {/* Destination Details Best Time Visit Section Start*/}
  <div
    className="destination-dt-travel-season-section mb-100"
    id="scroll-section"
  >
    <div className="container">
      <div
        className="section-title text-center mb-50 wow animate fadeInDown"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <h2>Best Time to Visit</h2>
      </div>
      <div className="row g-4">


       {DestinationData?.best_time_to_visit?.map((item, index) => (
  <div className="row " key={index}>
    <div className="col-lg-6">
    <div className="travel-season-card">
      <div className="travel-season-top-area">
        
        <div className="travel-season-img">
          <img src={`https://planjourneysglobal.com/admin//${item.image}`} alt={item.weather} />
        </div>

        <div className="travel-season-content">
          <h5>{item.season}</h5>
          <span>Weather: {item.weather}</span>
        </div>
      </div>

    
    </div>
    </div>
        <div className="col-lg-6">
     <div className="travel-season-card">
    
<div className="travel-season-content">

          <div className="highlights-area da">
            <h6>Highlights:</h6>
            <div dangerouslySetInnerHTML={{ __html: item.highlights }} />
          </div>
        </div>
     
    </div>
     </div>
             <div className="col-lg-12">
      <span className="note">
        Perfect For: {item.perfect_for || "N/A"}
      </span>
      </div>
  </div>
  
))}

      </div>
    </div>
  </div>
  {/* Destination Details Best Time Visit Section End*/}
    {/* FAQs */}
 {validFaqs.length > 0 && (
  <div className="destination-dt-faq-section mb-100">
    <div className="container">
      <div className="faq-area">
        <div className="row justify-content-center mb-50">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title text-center">
              <h2>Questions &amp; Answer</h2>
              <p>
                We’re committed to offering more than just products—we provide
                exceptional experiences.
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
            <div className="faq-wrap">
              <div className="accordion accordion-flush" id="accordionFlushExample">
                {validFaqs.map((faq, i) => (
                  <div key={i} className="accordion-item">
                    <h5 className="accordion-header" id={`flush-heading${i}`}>
                      <button
                        className={`accordion-button ${i !== 0 ? "collapsed" : ""}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#flush-collapse${i}`}
                        aria-expanded={i === 0}
                      >
                        <span
                          dangerouslySetInnerHTML={{ __html: faq.question }}
                        />
                      </button>
                    </h5>

                    <div
                      id={`flush-collapse${i}`}
                      className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div
                        className="accordion-body"
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
  {/* Destination Details Faq Section Start*/}


</>


      <Footer />
    </>
  );
}

export default DestinationList;
